import Cookies from 'js-cookie';
import { cookieDomain, PROTOCOL, COOKIES_EXPIRES_IN_DAYS, SHARE } from 'constants';
import store from 'store2';
import isString from 'lodash/isString';

const useCookies = !SHARE;
const useSession = SHARE;

class SessionStore extends Object {
  set(key, value) {
    const val = isString(value) ? value : JSON.stringify(value);
    if (useCookies) {
      try {
        Cookies.set(key, val, {
          domain: cookieDomain(),
          secure: PROTOCOL === 'https',
          sameSite: PROTOCOL === 'https' ? 'None' : 'Lax',
          expires: COOKIES_EXPIRES_IN_DAYS,
        });
      } catch (e) {
        console.error(e);
      }
    } else if (useSession) {
      sessionStorage.setItem(key, val);
    } else {
      store(key, val);
    }
  }

  get(key) {
    if (useCookies) {
      return Cookies.get(key);
    } else if (useSession) {
      return sessionStorage.getItem(key);
    }
    return store(key);
  }

  delete(key) {
    if (useCookies) {
      return Cookies.remove(key, { domain: cookieDomain() });
    } else if (useSession) {
      return sessionStorage.removeItem(key);
    }
    return store.remove(key);
  }
}

export default new SessionStore();
